<template>
  <div style="width: 100%">
    <v-toolbar flat dense>
      <v-toolbar-title>Generators</v-toolbar-title>
      <v-divider class="mx-2" inset vertical/>
      <v-btn @click="row_create" small class="ma-2" color="primary">ADD</v-btn>
      <v-spacer/>
    </v-toolbar>
    <v-expansion-panels>
      <v-expansion-panel
          v-for="(item,i) in items"
          :key="i"
      >
        <v-expansion-panel-header v-slot="{ open }">
          <v-row no-gutters>
            <span style="margin-top: 5px">{{ item.name || "Generator: " + i }}</span>
            <v-spacer/>
            <v-fade-transition>
              <span style="display: inline-flex" v-if="open">
                  <v-icon @click.native.stop="row_copy(item)" class="mr-2" small color="green darken-1">mdi-content-copy</v-icon>
                  <v-icon @click.native.stop="row_remove(item)" class="mr-2" small color="red darken-1">mdi-delete</v-icon>
                  <v-divider class="mx-1" vertical/>
              </span>
            </v-fade-transition>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <r-reward-generator-model :model.sync="item" :view_flags="view_flags"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {RewardGeneratorModel} from "@/modules/redactor/models/reward-generator/RewardGeneratorModel";
import RRewardGeneratorModel from "@/modules/redactor/views/reward-generator/r-reward-generator-model.vue";


export default {
  name: "r-reward-generator-panels",
  components: {RRewardGeneratorModel},
  props: {
    items: VueTypes.arrayOf(RewardGeneratorModel).isRequired,
    view_flags: VueTypes.integer.def(0xFFFF)
  },
  methods: {
    row_copy(item) {
      this.items.push(item.copy());
    },
    row_create() {
      this.items.push(new RewardGeneratorModel());
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      });
    }
  }
}

</script>